import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSunsetOutlined = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M8 1.833v.687M2.519 8.167h-.686m11.649 0h.685m-2.291-4.04.484-.485M1.833 10.833h12.334M4.5 13.5h7M4.125 4.128l-.485-.486m1.527 4.525v-.162A2.836 2.836 0 0 1 8 5.167a2.836 2.836 0 0 1 2.833 2.838v.162"
	})
});
export default SvgSunsetOutlined;
